import { useMemoizedFn } from 'ahooks'
import { storage } from '@/hooks/useIknow'
import { useState, useMemo } from 'react'
import { useSelector } from 'dva'

export const useCollapsedControl = (name: string) => {
    const queryFilterKey = useMemo<string>(() => {
        const tableNameAndId = `${name}_queryFilter`

        return `${tableNameAndId}_collapsed`
    }, [])

    const uid = useSelector(state => state?.user?.currentUser?.uid)

    const [collapsed, setCollapsed] = useState(() => {
        const arr = storage.get(queryFilterKey) || []
        if (arr.indexOf(uid) > -1) {
            return true
        } else {
            return false
        }
    })

    const toggleCollapsed = useMemoizedFn(() => {
        setCollapsed((prevState: boolean) => {
            const bool = !prevState
            setMemoCollapsed(bool)
            return bool
        })
    })

    const setMemoCollapsed = useMemoizedFn(bool => {
        // 只记录 true 收起
        let arr = storage.get(queryFilterKey) || []
        const index = arr.indexOf(uid)
        if (index > -1 && !bool) {
            arr.splice(index, 1)
        }

        if (index === -1 && bool) {
            arr.push(uid)
        }

        storage.set(queryFilterKey, arr)
    })

    return { collapsed, toggleCollapsed }
}
